<!-- Recent Reports -->
<app-recent-reports [reports]="recentReports()" [maxVisible]="maxVisibleReports" [colorVariant]="colorVariant"
  [entityType]="entityType">
</app-recent-reports>

<!-- Status Report Section (multi-select, does NOT auto-send) -->
<div class="status-report-section section-margin-s" [class]="'variant-' + colorVariant" [class.saved]="sendSuccess()">
  <div class="status-header">
    <span class="status-title head head-medium ">{{ 'socialSection.reportStatus' | t }}</span>
    @if (sendSuccess()) {
    <span class="status-badge success p-medium">{{ 'socialSection.sent' | t }}</span>
    }
  </div>

  <!-- Status buttons -->
  <div class="status-scroll-container antipadding-m padding-y-s">
    @if (showLeftArrow()) {
    <button class="scroll-arrow left" (click)="scrollStatusLeft()" aria-label="Scroll left">
      <img src="assets/icons/chevron-left.svg" class="arrow-icon" alt="">
    </button>
    }
    <div class="status-buttons-wrapper no-scrollbar inner-scroll" #statusScrollWrapper (scroll)="onStatusScroll()">
      <div class="status-buttons-grid">
        @for (status of statuses; track status.id) {
        <app-pill [label]="status.label | t" [iconSrc]="status.icon" [selected]="isStatusSelected(status.id)"
          [disabled]="isSending()" [variant]="colorVariant" size="md" (toggle)="toggleStatus(status.id)">
        </app-pill>
        }
      </div>
    </div>
    @if (showRightArrow()) {
    <button class="scroll-arrow right" (click)="scrollStatusRight()" aria-label="Scroll right">
      <img src="assets/icons/chevron-right.svg" class="arrow-icon" alt="">
    </button>
    }
  </div>
</div>

<!-- Comment Input (always visible, shared with report flow) -->
<div class="comment-input-section">
  <app-input #commentInput [data]="newCommentText" (dataSend)="newCommentText = $event"
    [placeholder]="hasSelectedStatuses ? ('socialSection.addReportComment' | t) : ('socialSection.addComment' | t)"
    type="textarea" [textarea]="true" rows="3" [readonly]="isSending()">
  </app-input>

  <div class="submit-row">
    <!-- Selected status pills summary -->
    @if (hasSelectedStatuses) {
    <div class="selected-statuses-summary">
      @for (statusId of selectedStatuses(); track statusId) {
      <app-pill [label]="getStatusLabel(statusId)" [iconSrc]="getStatusIcon(statusId)" [selected]="true"
        [removable]="true" [variant]="colorVariant" size="sm" (remove)="toggleStatus(statusId)">
      </app-pill>
      }
    </div>
    }

    <!--     [class.primary-invert-color-button]="colorVariant === 'primary'"
    [class.secondary-invert-color-button]="colorVariant === 'secondary'"
    [class.cuaternary-invert-color-button]="colorVariant === 'cuaternary'" -->

    <div class="push-btn comment-btn btn-s primary-invert-color-button" [class.disabled]="!canSubmit">
      <button (click)="submit()" [disabled]="!canSubmit" class="add-comment-btn contact-button inner-button p-bold"
        [class.disabled]="!canSubmit">
        @if (isSending()) {
        <app-spinner size="sm" />
        <span>{{ 'socialSection.sending' | t }}</span>
        } @else {
        <span>{{ submitLabel }}</span>
        }
      </button>
    </div>
  </div>
</div>

<!-- Success message -->
@if (sendSuccess()) {
<div class="success-message">
  <img src="assets/icons/check.svg" class="icon-success icon-16" alt="Enviado">
  <span class="saved-text sub">{{ 'socialSection.thankYou' | t }}</span>
</div>
}

<!-- Comments Header -->
@if (!isLoading() && comments().length > 0) {
<div class="comments-header section-margin-sm">
  <h4><span>{{ 'socialSection.comments' | t }}</span></h4>
</div>
}

<!-- Loading State -->
@if (isLoading()) {
<div class="comments-loading margin-t-m">
  <app-spinner size="md" />
  <span class="sub">{{ 'socialSection.loadingComments' | t }}</span>
</div>
}

<!-- Comments + Reports List -->
@if (!isLoading() && comments().length > 0) {
<div class="comments-list margin-t-m">
  @for (item of comments(); track item.id) {
  <div class="comment-item" [class.is-report]="item.type === 'report'">
    <!-- Report tags -->
    @if (item.type === 'report' && item.reportTypes && item.reportTypes.length > 0) {
    <div class="report-tags">
      @for (rt of item.reportTypes; track rt) {
      <app-pill [label]="getStatusLabel(rt)" [iconSrc]="getStatusIcon(rt)" [selected]="true" [disabled]="true"
        [variant]="colorVariant" size="xs">
      </app-pill>
      }
    </div>
    }
    <div class="comment-header">
      <span class="comment-author b-semibold">@{{ item.author }}</span>
      <span class="comment-date sub">{{ formatDate(item.date) }}</span>
    </div>
    @if (item.text) {
    <p class="comment-text">{{ item.text }}</p>
    }
  </div>
  }
</div>
}

<!-- Empty State -->
<!-- @if (!isLoading() && comments().length === 0) {
<div class="comments-empty margin-t-m">
  <span class="b text-tertiary">{{ 'socialSection.beFirstToComment' | t }}</span>
</div>
} -->